export default function SideSheetsFooter({ children }) {
  return (
    <div className="bg-white dark:bg-blackFont-800 flex flex-col absolute bottom-0 items-center justify-center gap-4 px-6 py-4 w-full border-t-1 border-t-light-grey dark:border-t-blackFont-700">
      {children}
    </div>
  );
}
